// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AdobeInDesignIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#49021F"
      d="M5.54 2h12.92A3.6 3.6 0 0 1 22 5.63v12.74c0 2-1.58 3.63-3.54 3.63H5.54A3.6 3.6 0 0 1 2 18.37V5.63C2 3.63 3.58 2 5.54 2"
    />
    <path
      fill="#F36"
      d="M9.27 7.23v8.8q0 .15-.12.14H7.52q-.12 0-.11-.14v-8.8q0-.12.12-.11h1.62q.09 0 .1.09.03 0 .02.02M14.08 16.27q-.93.01-1.79-.38a3 3 0 0 1-1.26-1.16 4 4 0 0 1-.45-1.95 3.6 3.6 0 0 1 1.78-3.13 4 4 0 0 1 2.28-.49l.26.02v-2.7q0-.1.08-.1h1.7q.06 0 .08.06v8.16q0 .22.02.51l.03.5q0 .09-.08.13a6 6 0 0 1-2.65.53m.82-1.7V10.8l-.22-.04-.28-.02q-.5 0-.94.23-.43.21-.71.63-.27.41-.27 1.08-.01.46.14.88.12.35.37.61.24.23.57.34.34.12.7.11a4 4 0 0 0 .64-.06"
    />
  </svg>,
  "AdobeInDesign",
);
export default AdobeInDesignIcon;
